import { render, staticRenderFns } from "./DashboardRouteCard.vue?vue&type=template&id=74e979ac&scoped=true"
import script from "./DashboardRouteCard.vue?vue&type=script&lang=js"
export * from "./DashboardRouteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e979ac",
  null
  
)

export default component.exports